import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import { cn } from '@/components/ui/utils';

const { FiGrid, FiUploadCloud, FiUsers, FiTerminal, FiZap, FiX, FiLayers } = FiIcons;

const navItems = [
  { name: 'Dashboard', path: '/', icon: FiGrid, desc: 'Live Analytics' },
  { name: 'Upload Users', path: '/upload', icon: FiUploadCloud, desc: 'Batch Import' },
  { name: 'All Users', path: '/users', icon: FiUsers, desc: 'User Management' },
];

const globalItems = [
  { name: 'All Schemes', path: '/schemes', icon: FiLayers, desc: 'Campaign Config' },
  { name: 'API Logs', path: '/logs', icon: FiTerminal, desc: 'System Events' },
];

const Sidebar = ({ isOpen, onClose }) => {
  const renderNavLink = (item) => (
    <NavLink
      key={item.name}
      to={item.path}
      end={item.path === '/'}
      onClick={onClose}
      className={({ isActive }) => cn(
        "flex items-center justify-between rounded-2xl px-4 py-3.5 transition-all duration-300 group relative",
        isActive ? "bg-primary-600/10 text-primary-400 border border-primary-500/20" : "text-surface-400 hover:bg-surface-900 hover:text-white border border-transparent"
      )}
    >
      {({ isActive }) => (
        <>
          <div className="flex items-center space-x-4">
            <div className={cn(
              "w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300",
              isActive ? "bg-primary-600 text-white shadow-lg shadow-primary-600/20" : "bg-surface-900 group-hover:bg-surface-800"
            )}>
              <SafeIcon icon={item.icon} className="w-5 h-5" />
            </div>
            <div>
              <p className="text-sm font-bold tracking-wide">{item.name}</p>
              <p className="text-[10px] font-medium mt-0.5 opacity-60">{item.desc}</p>
            </div>
          </div>
          {isActive && <div className="w-1.5 h-1.5 rounded-full bg-primary-500" />}
        </>
      )}
    </NavLink>
  );

  return (
    <aside className={cn(
      "fixed inset-y-0 left-0 z-50 flex flex-col w-72 transition-all duration-300 ease-in-out md:static md:translate-x-0 border-r border-surface-800",
      "bg-surface-950",
      isOpen ? "translate-x-0" : "-translate-x-full"
    )}>
      <div className="flex items-center justify-between h-20 px-8 border-b border-surface-800/50">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-primary-500/20">
            <SafeIcon icon={FiZap} className="w-5 h-5 text-white" />
          </div>
          <div>
            <h2 className="text-white font-black text-lg tracking-tight leading-none uppercase">Rewards</h2>
            <p className="text-primary-400 text-[10px] font-bold uppercase tracking-[0.2em] mt-1">Admin v1.0</p>
          </div>
        </div>
        <button onClick={onClose} className="md:hidden text-surface-400 hover:text-white p-2">
          <SafeIcon icon={FiX} className="w-5 h-5" />
        </button>
      </div>

      <div className="px-6 py-8 overflow-y-auto custom-scrollbar flex-1">
        <p className="text-surface-500 text-[10px] font-black uppercase tracking-[0.25em] mb-4 ml-2">Navigation</p>
        <nav className="space-y-2">
          {navItems.map(renderNavLink)}
          
          {/* Minimalist Divider */}
          <div className="py-4 px-2">
            <div className="h-px bg-surface-800/50 w-full" />
          </div>

          <p className="text-surface-500 text-[10px] font-black uppercase tracking-[0.25em] mb-4 ml-2">Global Management</p>
          {globalItems.map(renderNavLink)}
        </nav>
      </div>

      <div className="p-6">
        <div className="rounded-[1.5rem] bg-gradient-to-br from-surface-900 to-surface-950 p-5 border border-surface-800">
          <div className="flex items-center space-x-3 mb-3">
            <div className="w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-pulse" />
            <span className="text-xs font-bold text-surface-300 tracking-wide">Live Status</span>
          </div>
          <p className="text-[10px] text-surface-500 font-medium">System operational.</p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;